import React from 'react';

const defaultValues = {
  docName: '',
  docNameActivity: '',
  funds: [],
  fundsActivity: [],
  investors: [],
  typePickerBoard: false,
  typePickerDocument: false,
  investorsActivity: [],
  classifications: [],
  classificationsActivity: [],
  read: '',
  publishChecked: false,
  effectiveChecked: false,
  fromPublishDate: '',
  toPublishDate: '',
  asOfDate: '',
  fromDate: '',
  toDate: '',
  period: '',
  classificationToggle: false,
  fundsToggle: false,
  investorsToggle: false,
  periodToggle: false,
  slicerChoices: [],
  initialGroup: [],
  activityFeedFromDate: 0,
  setToDate: (e) => {},
  setFromDate: (e) => {},
  setPublishChecked: (e) => {},
  setEffectiveChecked: (e) => {},
  setAsOfDate: (e) => {},
  setPeriod: (e) => {},
  setTypePickerBoard: (e) => {},
  setTypePickerDocument: (e) => {},
  setClassificationToggle: (e) => {},
  setFundsToggle: (e) => {},
  setInvestorsToggle: (e) => {},
  setPeriodToggle: (e) => {},
  setSlicerChoices: (e) => {},
  setInitialGroup: (e) => {},
  setActivityFeedFromDate: (e) => {},
  clearFilters: () => {},
  clearFiltersActivity: () => {},
  hasFilters: () => {
    return false;
  },
  hasActivityFilters: () => {
    return false;
  },
};

const FilterCtx = React.createContext(defaultValues);

export default FilterCtx;
